// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3c4vX","switch__label":"switch__label-3bC79","description":"description-5UIz7","switch__icon":"switch__icon-3X8Py"};